import React from "react"
import SignupLayout from ".";
import BackgroundImg from "../../assets/images/background/check-email.png";
import { MailIconSignUp, SignupArrow } from "../../components/Icons/iconImages";
import InputField from "../../components/InputField";
import { validationConstants } from "../../constants/validations";
import { Button } from "antd";
import { set, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Icons from '../../components/Icons';
import { confirmSignUp, resendVerificationCode, signInCognitoUser } from "../../services/auth";
import { useVerifyEmailMutation } from "../../services/authSlice";
import ReactGA from "react-ga4";
import { toast } from "../../components/Toast/toast";


const VerifyEmail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const defaultValues = {
        code: '',
    };
    const {
        getValues,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues,
    });
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');
    const [verifyEmail] = useVerifyEmailMutation();

    const handleSignUp = async () => {
        setLoading(true);
        try {
            const user = await confirmSignUp(location?.state?.email, getValues('code'))
            if (user) {
                // Sign in the user after email confirmation to establish a session
                await signInCognitoUser(location?.state?.email, location?.state?.password);

                // Verify email with backend
                verifyEmail({ email: location?.state?.email })
                    .unwrap()
                    .then((res) => {
                        if (res) {
                            ReactGA.event('email_verification', {
                                method: 'OTP',
                                user_type: 'new_user',
                            });

                            setLoading(false);
                            navigate('/enter-referral-code', {
                                state: location?.state
                            });
                            toast.success('Account created successfully')
                        }
                    })
                    .catch((err) => {
                        setError(err?.data?.message || err?.error);
                        setLoading(false);
                    })
            }
        } catch (err: any) {
            setLoading(false);
            setError(err?.message)
        }
    }
    const handleSubmitError = (data: any) => {
        // console.log('error triggered', data)
    }
    const resend = async () => {
        setLoading(true);
        try {
            const user = await resendVerificationCode(location?.state?.email);
            if (user) {
                toast.success('Verification code resent successfully')
                setLoading(false);
            }
        } catch (err: any) {
            setError(err?.message)
            setLoading(false);
        }
    }

    return (
        <SignupLayout
            title={<p className="text-[#FFFFFF] font-bold text-6xl 2xl:text-7xl mt-3">Stop Guessing. <br />Start Growing.</p>}
            description={<p className="text-[#FFFFFF] text-xl mt-3">Connect your platforms and let AI answer your toughest marketing questions—instantly.</p>}
            icon={<SignupArrow className="h-[80px] w-[80px] " />}
            percent={15}
            currentStep={1}
        >
            <div className="h-[calc(100vh-19rem)] max-w-[480px] mx-auto w-full">
                <div className=" text-center mt-8">
                    <div className="border border-gray-300 w-[56px] h-[56px] rounded-xl flex items-center justify-center m-auto shadow-sm">
                        <MailIconSignUp className="w-[28px] h-auto" />
                    </div>
                    <p className="text-[#181D27] font-semibold text-3xl mt-4">Check your email</p>
                    <p className="text-[#535862] text-md mt-2">Enter the verification code sent to <span className="font-semibold">{location?.state?.email}</span></p>
                </div>
                <form onSubmit={handleSubmit(handleSignUp, handleSubmitError)} className="flex flex-col items-center justify-between mt-6 h-full gap-6">
                    <div className="max-w-[416px] w-full rounded-2xl flex flex-col space-y-4 md:space-y-4 h-full">

                        <InputField
                            control={control}
                            label={''}
                            placeholder={'Enter secret code'}
                            name="code"
                            rules={{
                                required: 'Code is required',
                                ...validationConstants.required,
                            }}
                            error={errors.code}
                        />
                        {error && (
                            <div className="flex items-center justify-between w-full border-t border-gray-200 dark:border-gray-600 pt-4">
                                <p className='text-red-500 text-sm'>{error}</p>
                                <Icons icon={"heroicons-outline:x-circle"} className="max-h-5 max-w-5 h-5 w-5 text-red-500 cursor-pointer" onClick={() => setError('')} />
                            </div>
                        )}
                    </div>
                    <div className="w-full max-w-[416px] space-y-2">
                        <Button
                            type='primary'
                            className="w-full"
                            disabled={loading}
                            loading={loading}
                            // onClick={() => handleSignUp()}
                            htmlType="submit"

                        >
                            Continue
                        </Button>
                        <p className="text-[#535862] font-normal text-base text-center">Did not receive the code? <span className="text-[#609F81] font-semibold cursor-pointer" onClick={resend}>Resend</span></p>
                    </div>
                </form>
            </div>
        </SignupLayout>
    )
};

export default VerifyEmail;
